// extracted by mini-css-extract-plugin
export default {"flag":"flag-module--flag--ba019","sv":"flag-module--sv--a9c21","en":"flag-module--en--709fc"};